import {
    ActiveState,
    EntityState,
    EntityStore,
    StoreConfig,
} from "@datorama/akita";
import { singleton } from "tsyringe";

import InstagramStoryEntity from "../entities/InstagramStoryEntity";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface InstagramStoriesState
    extends EntityState<InstagramStoryEntity, number>,
        ActiveState {}

@singleton()
@StoreConfig({ name: "instagram-stories", idKey: "id" })
class InstagramStoriesStore extends EntityStore<InstagramStoriesState> {}

export default InstagramStoriesStore;
